// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b6099136","703":"5d19061e"}[chunkId] + ".chunk.js";
};